// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"de2347a6","129":"34b02b18","135":"a18e85b8","213":"75b86e40","649":"b78f2968","693":"94031f10","716":"61995e9b","717":"5cfa4c97"}[chunkId] + ".chunk.css";
};